<template>
  <div>
    <div class="nav">
      <v-head></v-head>
    </div>
    <v-route :bindData="bindData0"></v-route>
    <div class="container">
      <div class="container_box">
        <v-breadcrumb value1="首页" value2="搜索"></v-breadcrumb>
        <el-input
          style="width: 280px; margin-top: 10px"
          placeholder="请输入内容"
          v-model="content"
        >
        </el-input>
        <el-button @click="search" style="margin-left: 10px" type="primary"
          >查询</el-button
        >
        <div class="box_item mt20" v-for="(i, index) in dataList" :key="index">
          <img class="i hover" :src="i.coverImageUrl" @click="toDetail(i)" />
          <div class="item_right">
            <div class="right_title hover" @click="toDetail(i)">
              {{ i.title }}
              <!-- <img style="float: right;margin-right: 50px" src="../../assets/img/share.png">-->
            </div>
            <p>
              {{ i.summary }}
            </p>
            <div class="right_down">
              时间:{{ i.time }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span class="hover" @click="toDetail(i)">阅读全文 >></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
import route from "../../components/common/route3";
export default {
  name: "list1",
  data() {
    return {
      content: null,
      ljcode: null,
      columnId: null,
      rootColumnId: null,
      dataList: null,
      url: null,
      bindData0: [
        
      ],
    };
  },
  created() {
    console.log("aaaa");

    this.getList();
  },
  watch: {
    $route() {
      this.rootColumnId = this.$route.query.parent;
      this.columnId = this.$route.query.id;
    },
    columnId(v1, v2) {
      if (v1 != v2) {
        this.getList();
      }
    },
  },
  methods: {
    search() {
      console.log(this.rootColumnId);
      var arr = this.rootColumnId.split("?");
      let url = `${api}/api/cms/article/list?rootColumnId=${arr[0]}&columnId=${this.columnId}&pageSize=20&currentPage=1&title=${this.content}`;
      this.common.axios.get(url).then((v) => {
        let data = v.data.data.list;
        data.forEach((v) => {
          v.coverImageUrl = apiimg + v.coverImageUrl;
          v.path = `rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&articleId=${v.id}`;
        });
        this.dataList = data;
        console.log(data, "data");
      });
    },
    getList() {
      if (this.$route.query.rootColumnId) {
        this.rootColumnId = this.$route.query.rootColumnId;
        this.columnId = this.$route.query.columnId;
      }
      if (
        this.$route.query.parent == "null" &&
        !this.$route.query.rootColumnId
      ) {
        this.rootColumnId = this.$route.query.id;
        let url = `${api}/api/cms/column/list?rootColumnId=${this.rootColumnId}`;
        this.common.axios.get(url).then((v) => {
          var arr = [
            {
              cid: null,
              name: null,
              url: null,
              pid:null
            },
          ];
          var data = v.data.data;
          arr.length = data.length;
          for (var i = 0; i < data.length; i++) {
            arr[i].cid = data[i].id;
            arr[i].name = data[i].name;
            arr[i].url = `#/xzlm?id=${data[i].id}&parent=${data[i].parent.id}`;
            arr[i].pid = data[i].parent.id
         }
          this.bindData0 = arr;
          console.log(this.bindData0, "bindData0");
          // this.$route.query.parent=arr[0].pid
          this.$route.query.id=arr[0].cid
          this.rootColumnId=arr[0].pid
          this.columnId=arr[0].cid
        });
      }
      if (
        !this.$route.query.rootColumnId &&
        this.$route.query.parent != "null"
      ) {
        this.rootColumnId = this.$route.query.parent;
        this.columnId = this.$route.query.id;
         let url = `${api}/api/cms/column/list?rootColumnId=${this.rootColumnId}`;
         this.common.axios.get(url).then((v) => {
          var arr = [
            {
              cid: null,
              name: null,
              url: null,
              pid:null
            },
          ];
          var data = v.data.data;
          arr.length = data.length;
          for (var i = 0; i < data.length; i++) {
            arr[i].cid = data[i].id;
            arr[i].name = data[i].name;
            arr[i].url = `#/xzlm?id=${data[i].id}&parent=${data[i].parent.id}`;
            arr[i].pid = data[i].parent.id
         }
          this.bindData0 = arr;
          console.log(this.bindData0, "bindData0");
          // this.$route.query.parent=arr[0].pid
          this.$route.query.id=arr[0].cid
          // this.rootColumnId=arr[0].pid
          this.columnId=arr[0].cid
        });
      }
      let that = this;
      console.log(that.columnId, this.rootColumnId, "root");
      let url = `${api}/api/cms/article/list?rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&type=&pageSize=20&currentPage=1`;
      this.common.axios.get(url).then((v) => {
        let data = v.data.data.list;
        data.forEach((v) => {
          v.coverImageUrl = apiimg + v.coverImageUrl;
          v.path = `ljcode=${this.ljcode}&rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&articleId=${v.id}`;
          v.time = that.common.date2Local(v.createDate);
        });
        this.dataList = data;
      });
    },
    toDetail(v) {
      console.log(v);
      if (this.$route.query.type == "住宿") {
        let url = `/zs?rootColumnId=${this.$route.query.rootColumnId}&columnId=${this.$route.query.columnId}&articleId=${v.id}`;
        this.$router.replace({ path: url });
      } else if (this.$route.query.type == "游玩") {
        let url = `/yw?rootColumnId=${this.$route.query.rootColumnId}&columnId=${this.$route.query.columnId}&articleId=${v.id}`;
        this.$router.replace({ path: url });
      } else if (this.$route.query.type == "美食") {
        let url = `/ms?rootColumnId=${this.$route.query.rootColumnId}&columnId=${this.$route.query.columnId}&articleId=${v.id}`;
        this.$router.replace({ path: url });
      } else if (this.$route.query.type == "娱乐") {
        let url = `/yl?rootColumnId=${this.$route.query.rootColumnId}&columnId=${this.$route.query.columnId}&articleId=${v.id}`;
        this.$router.replace({ path: url });
      } else if (this.$route.query.type == "购物") {
        let url = `/gw?rootColumnId=${this.$route.query.rootColumnId}&columnId=${this.$route.query.columnId}&articleId=${v.id}`;
        this.$router.replace({ path: url });
      } else if (this.$route.query.type == "特产") {
        let url = `/tc?rootColumnId=${this.$route.query.rootColumnId}&columnId=${this.$route.query.columnId}&articleId=${v.id}`;
        this.$router.replace({ path: url });
      } else {
        this.$router.push({ path: `/detail4?${v.path}` });
      }
    },
  },
  components: {
    "v-route": route,
  },
};
</script>

<style lang="less" scoped>
.nav {
  height: 350px;
  background: url("../../assets/img/headerbanner.jpg");
}
.container_box {
  .box_top {
    width: 400px;
    height: 22px;
    line-height: 22px;
    font-size: 16px;
    color: #159089;
    text-align: left;
    margin: 20px 0 20px 10px;
  }
  .box_item {
    height: 200px;
    border-radius: 4px;
    margin-bottom: 20px;
    border-bottom: 2px solid rgb(235, 235, 235);
    display: flex;
    .i {
      width: 296px;
      height: 170px;
      margin-right: 20px;
    }
    .item_right {
      flex: 1;
      text-align: left;
      .right_title {
        margin-bottom: 20px;
        height: 20px;
        line-height: 20px;
        color: rgba(51, 51, 51, 1);
        font-size: 18px;
      }
      p {
        font-size: 14px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 20px;
      }
      .right_down {
        margin-top: 20px;
        margin-right: 20px;
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }
    }
  }
}
</style>
